import React, { useEffect, useRef, useState } from "react";
import { ROUTE_PATH } from "@static/route-paths";
import { styled } from "@linaria/react";
import UwqList from "./UwqList";
import { HeightAndWeight, HeightAndWeightModel } from "./HeightAndWeight";
import { postUWQuestionRequest } from "@api/index";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { setLoadingState } from "@redux/slices/loadingSlice";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import { scrollToRef } from "../../../../utils/scrollScript";
import { calculateSpacer } from "@utils/spaceCalculation";
import { Link as LinkDom } from "react-router-dom";
import Icon from "@components/_Revamp/Icon";
import {
  updateHeightAndWeight,
  updateUWQCompleted,
  updateUWQuestions,
} from "@redux/slices/SHIELD_STARTER/step4Slice";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import {setTooltipPosition} from "./../../Components/Tooltip";
import Stepper from "@pages/ShieldStarter/Components/Stepper";
import { STEPS_LIST } from "@static/content";
import ErrorModal from "@pages/ShieldStarter/Components/Modals/ErrorModal";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";

const Container = styled.div`
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  max-width: ${CONTAINER_SIZE.mobiles}px;
  margin-top: 132px;
  padding: 0 24px;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      max-width: ${CONTAINER_SIZE.desktops}px;
  }
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-top: 64px;
    padding: 0 100px;
  }
`;

const SectionContainer = styled.div<{ margin?: string; width?: string }>`
  background-color: #ffffff;
  border-radius: 24px;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  transition: all 0.2s ease;
  /* margin: 36px 0 0; */
  padding: 24px 16px;
  scroll-margin-top: 132px;

  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-top: 64px;
    scroll-margin-top: 150px;
    padding: 36px;
  }
`;

const BackButton = styled.div`
  max-width: 365px;
  width: 100%;

  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  @media screen and (min-width: 768px) {
    max-width: 828px;
  }
`;

function HealthDeclaration() {
  const history = useHistory();
  const dispatch = useAvivaDispatch();
  const whomToBuy = useAvivaSelector(
    (state) => state.shieldStarterStep1.whomToBuy
  );
  const personalInfo = useAvivaSelector(
    (state) => state.shieldStarterStep3.personalInfo
  );
  const selectedChildInfo = useAvivaSelector(
    (state) => state.shieldStarterStep3.selectedChildInfo
  );
  const heightAndWeight = useAvivaSelector(
    (state) => state.shieldStarterStep4.heightAndWeight
  );
  const isCompleted = useAvivaSelector(
    (state) => state.shieldStarterStep4.isCompleted
  );
  const [isHeightAndWeightComplete, setIsHeightAndWeightComplete] = useState(
    isCompleted
  );
  const IllessSelectionRef = useRef<null | HTMLDivElement>(null);
  const SpacerRef = useRef<null | HTMLDivElement>(null);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isValueChanged,setIsValueChanged] = useState(false);
  const bmiCheckedAttempts = useAvivaSelector((state)=>state.shieldStarterStep4.bmiChecked)

  const callTooltipPosition = () => {
    setTooltipPosition(screenSize);
  }

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
    setTooltipPosition(window.innerWidth, true);
  };
  
  const resetUW = () => {
    setIsValueChanged(true);
    dispatch(updateUWQCompleted(false));
  };
  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  useEffect(() => {
    detectScreenWidth();
  }, [isValueChanged]);

  useEffect(()=>{
    document.addEventListener("scroll", callTooltipPosition);
    setTooltipPosition(window.innerWidth, true);
    return () => {
      window.removeEventListener("scroll", callTooltipPosition);
    };
  }, []);


  const [uwQuestions, setUwQuestions] = useState(null);
  useEffect(() => {
    const apiCAll = async (age: number) => {
      dispatch(setLoadingState(true));
      try {
        const { data }: any = await postUWQuestionRequest(age);
        dispatch(updateUWQuestions(data));
        dispatch(setLoadingState(false));
        setUwQuestions(data);
      } catch (error) {
        dispatch(setLoadingState(false));
        history.push(`${ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR}`);
      }
    };

    const myInfo: any = whomToBuy === "child" ? selectedChildInfo : personalInfo;
   
    if (!whomToBuy || isEmpty(myInfo)) {
      history.push(ROUTE_PATH.SHIELD_STARTER_GET_QUOTE);
    } else {
      trackOnLoad("sss_health_declaration_height_and_weight_form")
      apiCAll(myInfo?.age);
      if (IllessSelectionRef && IllessSelectionRef.current && isCompleted)
        IllessSelectionRef.current.style.opacity = "1";
      setIsHeightAndWeightComplete(isCompleted);
    }
  }, []);

  const onHeightAndWeightComplete = async ({
    height,
    weight,
  }: HeightAndWeightModel) => {
    setIsValueChanged(false);
    dispatch(updateHeightAndWeight({ ...heightAndWeight, height, weight }));
      
    if (IllessSelectionRef && IllessSelectionRef.current) {
      let unit = -10
      screenSize < SCREEN_SIZE.mobilesUp &&  (unit = 90)
      screenSize > SCREEN_SIZE.mobilesUp && screenSize < SCREEN_SIZE.mobileSteper && (unit = -42)
  
      IllessSelectionRef.current.style.opacity = "1";
      const elementOffsetTop = IllessSelectionRef.current.offsetTop;
      if (!isHeightAndWeightComplete) {
        setIsHeightAndWeightComplete(true);
      }
      const top = window.pageYOffset || document.documentElement.scrollTop;
      scrollToRef(
        document.documentElement,
        "scrollTop",
        unit,
        top,
        elementOffsetTop,
        300,
        true
      );
    }
  };

  return (
    <>
      <MainContainer step={4} backButtonPath={ROUTE_PATH.SHIELD_STARTER_MAILING_ADDRESS}>
        <SectionContainer>
          <HeightAndWeight
            onComplete={onHeightAndWeightComplete}
            values={{
              height: heightAndWeight?.height!,
              weight: heightAndWeight?.weight!,
            }}
            screenSize={screenSize}
            resetUW={resetUW}
          />
        </SectionContainer>
        <div ref={IllessSelectionRef} style={{ opacity: 0 }}>
          {!isValueChanged && uwQuestions && isHeightAndWeightComplete && (
            <UwqList questionsList={uwQuestions} screenSize={screenSize}/>
          )}
        </div>
      </MainContainer>
      <div ref={SpacerRef}></div>
      {bmiCheckedAttempts>3 && (
        <ErrorModal
          title="You may need some assistance"
          error="It looks like you might need assistance from a Financial Adviser Representative
          to find a more suitable plan for your needs."
        />
      )}
      <Stepper steps={STEPS_LIST} activeId={STEPS_LIST[3].id}></Stepper>
    </>
  );
}
export default HealthDeclaration;
